



































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DashboardRightbar extends Vue {
  @Prop({ default: false }) readonly hasHeader!: boolean;

  @Prop({ default: false }) readonly slideoutOpen!: boolean;
}
